
        
    const runtime = require("../../../../../../../../node_modules/simple-nunjucks-loader/lib/cjs/runtime.js");
    
    const __nunjucks_module_dependencies__ = {};
    
    __nunjucks_module_dependencies__.templates = {};
    __nunjucks_module_dependencies__.globals = {};
    __nunjucks_module_dependencies__.extensions = {};
    __nunjucks_module_dependencies__.filters = {};
    __nunjucks_module_dependencies__.assets = {};
    
    
    
    
    
    
        
            __nunjucks_module_dependencies__.templates["assessments/admin/views/templates/question-option.html"] = (function() {
                function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<input\n  name=\"text\"\n  type=\"text\"\n  value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "text"), env.opts.autoescape);
output += "\"\n  placeholder=\"Add an option...\"\n  tabindex=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "order") + 1, env.opts.autoescape);
output += "\"\n/>\n<div class=\"admin-controls\">\n  <a\n    href=\"javascript:void(0)\"\n    title=\"Make correct answer\"\n    class=\"correct tipsy-below\"\n    ><i class=\"fa fa-check\"></i\n  ></a>\n  <a href=\"javascript:void(0)\" class=\"move\"><i class=\"fa fa-arrows\"></i></a>\n  <a href=\"javascript:void(0)\" class=\"delete\"><i class=\"fa fa-trash-o\"></i></a>\n</div>\n<div class=\"delete-prompt\" style=\"display: none\">\n  Are you sure? You will lose any answers associated with this option.\n  <a class=\"delete-option ButtonLegacy medium rounded btn-danger\"\n    >Yes, Delete</a\n  >\n  or <a href=\"javascript:void(0)\" class=\"delete-cancel\">cancel</a>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

            })();
        

        function nunjucksTemplate(ctx = {}) {
            const templateContext = {
                __nunjucks_loader_assets__: __nunjucks_module_dependencies__.assets,
                ...ctx
            };

            var nunjucks = (runtime && runtime.default || runtime)(
                {"dev":false,"jinjaCompat":false,"isAsyncTemplate":false},
                __nunjucks_module_dependencies__
            );

            if (nunjucks.isAsync()) {
                return nunjucks.renderAsync(
                    "assessments/admin/views/templates/question-option.html",
                    templateContext
                );
            }
        
            return nunjucks.render(
                "assessments/admin/views/templates/question-option.html",
                templateContext
            );
        };

        nunjucksTemplate.__nunjucks_precompiled_template__ = __nunjucks_module_dependencies__.templates["assessments/admin/views/templates/question-option.html"];
        nunjucksTemplate.__nunjucks_module_dependencies__ = __nunjucks_module_dependencies__;

        exports = module.exports = nunjucksTemplate;
    